/*
  Belléa — motion
  Cero dependencias, solo APIs nativas. Cargado con defer (no bloquea el LCP).
  - Scroll reveal: IntersectionObserver + transición CSS, unobserve tras disparar.
  - Parallax hero: solo desktop, desactivado por completo en móvil y en
    prefers-reduced-motion: reduce.
*/
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. Scroll reveal ---------------------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll('.bellea-reveal');
    if (!els.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('bellea-reveal--in'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          // Retardo escalonado opcional vía data-reveal-delay (ms)
          var delay = parseInt(el.getAttribute('data-reveal-delay') || '0', 10);
          if (delay) el.style.transitionDelay = delay + 'ms';
          el.classList.add('bellea-reveal--in');
          obs.unobserve(el); // no seguimos escuchando
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
    );

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---- 2. Parallax hero (desktop únicamente) ------------------------- */
  function initParallax() {
    if (reduceMotion) return;
    // Solo desktop: en móvil el efecto se elimina, no se reduce.
    var desktop = window.matchMedia('(min-width: 990px) and (pointer: fine)');
    if (!desktop.matches) return;

    var media = document.querySelector('.bellea-parallax__media');
    if (!media) return;

    var section = media.closest('.bellea-parallax') || media.parentElement;
    var ticking = false;

    function update() {
      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      // Solo calcula cuando la sección está en viewport
      if (rect.bottom < 0 || rect.top > vh) { ticking = false; return; }
      var progress = (vh - rect.top) / (vh + rect.height); // 0..1
      var shift = (progress - 0.5) * 40; // ±20px, sutil
      media.style.transform = 'translate3d(0,' + shift.toFixed(2) + 'px,0) scale(1.08)';
      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ---- 3. Header: compactar + fondo al bajar --------------------------- */
  function initHeader() {
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        document.body.classList.toggle('bellea-scrolled', window.scrollY > 60);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- 4. Carrito: rebote sutil al cambiar la cantidad ----------------- */
  function initCart() {
    if (reduceMotion) return;
    var bubbleHost = document.getElementById('cart-icon-bubble');
    if (!bubbleHost) return;

    function bounce() {
      var target = bubbleHost.querySelector('.cart-count-bubble') || bubbleHost;
      target.classList.remove('bellea-cart-bounce');
      // reflow para reiniciar la animación
      void target.offsetWidth;
      target.classList.add('bellea-cart-bounce');
    }

    // El contenido del ícono se re-renderiza al actualizar el carrito.
    new MutationObserver(bounce).observe(bubbleHost, { childList: true, subtree: true });
  }

  function init() {
    initReveal();
    initParallax();
    initHeader();
    initCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
